import PropTypes from "prop-types";

import { TRANSACTION_UCAF_TYPES } from "../CONSTANTS";

function UCAFType(props) {
  const { type } = props;

  return TRANSACTION_UCAF_TYPES[type] || type;
}

UCAFType.displayName = "UCAFType";

UCAFType.propTypes = {
  type: PropTypes.number,
};

UCAFType.defaultProps = {};

export default UCAFType;



// WEBPACK FOOTER //
// ./src/components/processing/transaction/UCAFType.js